<template>
    <div class="wrap">
        <div class="wrap_inner" ref="iwrap">
            <div class="wrap_main">
                <div v-if="mShow" :class="{msShow:true,activeBottom:disShow}" class="msShow" :style="{top:0,bottom:0,overflow:disShow?'hidden':'auto'}">
                    <div class="blkm">
                        <img src="./image/my-banner@2x.png" style="position:absolute;top:0;left:0;width: 100%;height: 100%"></img>
                        <div class="blkps">
                            <div class="blkrect"></div>
                            <div class="txtku1">我的签名</div>
                        </div>
                    </div>
                    <div class="engSty" ref="engSign">
                        <vue-esign ref="esign" :isCrop="isCrop" :lineWidth="lineWidth" :lineColor="lineColor" :bgColor.sync="bgColor" id="canvas1" />
                        <div @click="handleReset" class="blkn">
                            <van-icon name="replay" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>重置</span>
                        </div>
                    </div>
                    <div class="blkj">
                        <div style="display:flex;justify-content:center;align-items:center;flex:1;">
                            <div class="blkh" @click="toSubmit">返回</div>
                        </div>
                        <div style="display:flex;justify-content:center;align-items:center;flex:1;">
                            <div @click="handleGenerate" class="blkp">保存</div>
                        </div>
                    </div>
                    <!-- <div v-if="disShow" style="width:100%;height:100%">
                        <div ref="dig" class="mtblk" style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:1000;opacity: 0.95;background: #333333;">
                            <div class="dialogs">
                                <div class="digtxt">签名一旦确认不可更改</div>
                                <div class="txtx" @click="reback"><img src="./image/x@2x.png" style="position:absolute;top:0;right:0;width:100%;height:100%"></img></div>
                                <div style="display:flex;align-items:center;justify-content:center">
                                    <div class="reback" @click="reback">返回</div>
                                    <div class="submit" @click="submit">确定</div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <van-dialog v-model:show="disShow" @cancel="reback" @confirm="submit" confirm-button-color="#108EE9" show-cancel-button>
                        <div class="digtxt3">
                            <img src="../../components/image/error.png" alt="" style="width: 35%;padding-top: 25px;">
                            <div style="padding: 20px 0;">签名一旦确认不可更改</div>
                            <!-- <van-field v-model="reasons1" style="border:1px solid #eee" rows="3" autosize type="textarea" placeholder="请输入流转原因" /> -->
                        </div>
                    </van-dialog>
                </div>

                <div v-if="!mShow">
                    <div class="blkm">
                        <img src="./image/my-banner@2x.png" style="position:absolute;width: 100%;height: 100%" />
                        <div class="blkps">
                            <div class="blkrect"></div>
                            <div class="txtku1">我的签名</div>
                        </div>
                    </div>
                    <div class="engSty" ref="engSign">
                        <img :src="resultImg" alt="" style="width:100%;height:100%" />
                    </div>
                    <div class="blkj">
                        <div style="display:flex;justify-content:center;align-items:center;flex:1;">
                            <div class="blkh brnReback" @click="toSubmit">返回</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PJXQ from "@/components/pjxq.vue";
export default {
    name: "autograph",
    components: { PJXQ },
    data() {
        return {
            lineWidth: 6,
            lineColor: "#000000",
            bgColor: "",
            resultImg: "",
            isCrop: false,
            disShow: 0,
            mShow: 0,
            signSrc: "",
        };
    },
    created() {
        this.getSign();
        this.$nextTick(() => {
            let h = window.getComputedStyle(this.$refs.engSign).height;
            let w = window.getComputedStyle(this.$refs.engSign).width;
            setTimeout(() => {
                this.$refs.esign.$el.height = parseFloat(h);
                this.$refs.esign.$el.width = parseFloat(w);
                this.$refs.esign.$el.style.height = h;
                this.$refs.esign.$el.style.width = w;
            }, 1000);
        });
    },
    mounted() {
        let h = window.getComputedStyle(this.$refs.engSign).height;
        let w = window.getComputedStyle(this.$refs.engSign).width;
        setTimeout(() => {
            this.$refs.esign.$el.height = parseFloat(h);
            this.$refs.esign.$el.style.height = h;
            this.$refs.esign.$el.width = parseFloat(w);
            this.$refs.esign.$el.style.width = w;
        }, 1000);
        this.getSign();
    },
    methods: {
        handleReset() {
            this.$refs.esign.reset(); //清空画布
        },
        dataURLtoBlob(dataurl, filename) {
            var arr = dataurl.split(","),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        handleGenerate() {
            let that = this;
            that.$refs.esign
                .generate()
                .then((res) => {
                    that.resultImg = res; //生成图片，这里生成的是base64格式
                    let val = new Date().getTime();
                    that.resultImg = that.dataURLtoBlob(
                        this.resultImg,
                        `img${val}.png`
                    );
                    that.disShow = 1;
                })
                .catch((err) => {});
        },
        reback() {
            this.disShow = 0;
        },
        submit() {
            const formData = new FormData();
            formData.append("file", this.resultImg);
            this.$api
                .post(`/common/upload`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                })
                .then((res) => {
                    if (res.data.code == "0000") {
                        this.$api
                            .post(`/app/user/update`, {
                                userId: this.$store.state.user.userInfo.userId,
                                esignature: res.data.data,
                            })
                            .then((res1) => {
                                if (res1.data.code == "0000") {
                                    this.getSign();
                                }
                            });
                    }
                });
        },
        getSign() {
            let engineerId = this.$store.state.user.userInfo.userId;
            let data = { userId: engineerId };
            this.$api.get(`/app/user/getUser`, { params: data }).then((res) => {
                if (res.data.code == "0000") {
                    if (res.data.data.esignature) {
                        this.disShow = 0;
                        this.mShow = 0;
                        // this.resultImg='http://180.100.77.186:9085/prod-yh'+res.data.data.esignature
                        // this.resultImg='http://180.100.77.186:9085/prod-yh'+res.data.data.esignature
                        this.resultImg =
                            process.env.VUE_APP_IMG_URL +
                            res.data.data.esignature;
                    } else {
                        this.disShow = 0;
                        this.mShow = 1;
                    }
                }
            });
        },
        toSubmit() {
            this.$router.push("/mine");
        },
    },
    watch: {
        disShow() {},
        mShow() {},
    },
};
</script>
<style scoped>
::v-deep .van-dialog {
    width: 75% !important;
}
.digtxt3 {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background: #e9eef2;
    overflow-x: hidden;
    z-index: 1000;
}
.wrap_inner {
    min-height: 100%;
    width: 100%;
}
.wrap_main {
    padding-bottom: 50px;
}
.mainlist {
    width: 100%;
    height: 340px;
}
.engSty {
    position: relative;
    padding-top: 45px;
    width: 100%;
    height: 274px;
    background: #ffffff;
    font-size: 12px;
    margin-top: 20px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    z-index: 1;
}
.bgblk {
    width: 100%;
    height: 667px;
}
.mtblk {
    width: 100%;
    height: 667px;
}
.txtx {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 12px;
    height: 12px;
    flex: 1;
}
.dialogs {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 285px;
    height: 179px;
    background: #fff;
    border-radius: 8px;
    z-index: 1000;
}
.digtxt {
    width: 200px;
    height: 28px;
    margin: 34px auto;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}
.reback {
    flex: 0 0 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: #ffffff;
    border: 2px solid #0080ff;
    border-radius: 23px;
    color: #0080ff;
    font-size: 18px;
}
.submit {
    flex: 0 0 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: linear-gradient(140deg, #36b3fe 4%, #0080ff 96%);
    border-radius: 23px;
    color: #fff;
    font-size: 18px;
    margin-left: 20px;
}
.isShow {
    display: block;
}
.isHidden {
    display: none;
}

.blkm {
    position: relative;
    width: 100%;
    height: 148px;
}
.blkn {
    position: absolute;
    right: 21px;
    top: 21px;
    font-size: 14px;
    font-weight: 700;
}

.blkj {
    display: flex;
    flex-direction: row;
    margin-top: 20px;
    padding: 20px;
    z-index: 3000;
}
.blkh {
    flex: 0 0 140px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    border-radius: 22px;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #0080ff;
    border: 2px solid #0080ff;
}
.blkp {
    flex: 0 0 140px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    background: linear-gradient(116deg, #36b3fe 11%, #0080ff 91%);
    border-radius: 22px;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
}
.brnReback {
    flex: 0 0 281px;
}
.msShow {
    position: absolute;
    width: 100%;
    height: 100%;
}
.activeBottom {
    margin-bottom: -50px;
}
.blkps {
    position: absolute;
    top: 48px;
    right: 52px;
    width: 90px;
    height: 90px;
}
.blkrect {
    width: 20px;
    height: 2px;
    background: #ffffff;
    z-index: 3000;
}
.txtku1 {
    margin: 4px 0 10px 0;
    font-size: 20px;
    font-weight: 800;
    text-align: left;
    color: #ffffff;
}
</style>
